import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import { FIELD_CONTROL_CLASS } from '@/styles/fieldControl';

interface SidebarSearchProps {
  value: string;
  onChange: (value: string) => void;
  inputClassName?: string;
}

export function SidebarSearch({ value, onChange, inputClassName }: SidebarSearchProps) {
  return (
    <div className="relative flex h-9.5 shrink-0 items-center">
      <Search className="pointer-events-none absolute top-1/2 left-4 size-4 -translate-y-1/2 text-brand-link/70 transition-[left,width,height] duration-300 ease-in-out group-data-[collapsible=icon]:left-(--sidebar-rail-inset) group-data-[collapsible=icon]:size-5" />
      <Input
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Search"
        aria-label="Search menu"
        className={cn(
          FIELD_CONTROL_CLASS,
          'h-full w-[calc(var(--sidebar-width)-2*var(--sidebar-inset))] py-0 pr-4 pl-10',
          'transition-[color,background-color,border-color,box-shadow] duration-300 ease-in-out',
          'group-data-[collapsible=icon]:border-transparent group-data-[collapsible=icon]:bg-transparent group-data-[collapsible=icon]:shadow-none',
          'group-data-[collapsible=icon]:hover:border-transparent group-data-[collapsible=icon]:hover:shadow-none',
          inputClassName,
        )}
      />
    </div>
  );
}
